import { COLORS, Ic, ICONS } from "@/lib/theme";
import { useIsDesktop } from "@/lib/media";

export default function BackHomeBar({ title, onBack, onHome }) {
  const isDesktop = useIsDesktop();
  if (isDesktop) return null;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "14px 18px 0" }}>
      <button onClick={onBack || onHome} aria-label="Back" className="no-tap-highlight"
        style={{ width: 40, height: 40, borderRadius: 20, border: `1px solid ${COLORS.border}`, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
        <Ic d={ICONS.back} color={COLORS.purple} size={21} />
      </button>
      <div className="font-heading" style={{ flex: 1, fontWeight: 800, fontSize: 18, color: COLORS.ink }}>{title}</div>
      <button onClick={onHome} aria-label="Home" className="no-tap-highlight"
        style={{ width: 40, height: 40, borderRadius: 20, border: `1px solid ${COLORS.border}`, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
        <Ic d={ICONS.home} color={COLORS.purple} size={20} />
      </button>
    </div>
  );
}
